<template lang="pug">

.filters
    span.filters__el
        buzz-multiradio(
            v-model="period",
            :options="period_names"
          )
    span.filters__el
        datepicker.filters__datepicker(
            v-model="periodRange",
            range,
            value-type="timestamp",
            :lang="'en'",
            :editable="false",
            :confirm="true",
            :confirm-text="$t('datepicker.btn')",
            range-separator=" — ",
            format="DD MMM YYYY"
        )

</template>

<script>
import moment from 'moment'
import datepicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

export default {
    name: 'date-filters',
    components: {
        datepicker,
    },
    props: {
        default_period: {
            type: Object,
        },
        all_filters: {
            type: Boolean,
        },
    },
    model: {
        event: 'changePeriod',
        prop: 'default_period',
    },
    data() {
        return {
            periods: {
                today: {
                    start_ts: moment().startOf('day').format('YYYY-MM-DD'),
                    end_ts: moment().endOf('day').format('YYYY-MM-DD'),
                },
                yesterday: {
                    start_ts: moment()
                        .subtract(1, 'days')
                        .startOf('day')
                        .format('YYYY-MM-DD'),
                    end_ts: moment()
                        .subtract(1, 'days')
                        .endOf('day')
                        .format('YYYY-MM-DD'),
                },
                seven_days: {
                    start_ts: moment()
                        .subtract(7, 'days')
                        .startOf('day')
                        .format('YYYY-MM-DD'),
                    end_ts: moment().endOf('day').format('YYYY-MM-DD'),
                },
                thirty_days: {
                    start_ts: moment()
                        .subtract(30, 'days')
                        .startOf('day')
                        .format('YYYY-MM-DD'),
                    end_ts: moment().endOf('day').format('YYYY-MM-DD'),
                },
                this_month: {
                    start_ts: moment().startOf('month').format('YYYY-MM-DD'),
                    end_ts: moment().endOf('day').format('YYYY-MM-DD'),
                },
                last_month: {
                    start_ts: moment()
                        .subtract(1, 'month')
                        .startOf('month')
                        .format('YYYY-MM-DD'),
                    end_ts: moment()
                        .subtract(1, 'month')
                        .endOf('month')
                        .format('YYYY-MM-DD'),
                },
                three_months: {
                    start_ts: moment()
                        .subtract(3, 'month')
                        .format('YYYY-MM-DD'),
                    end_ts: moment().format('YYYY-MM-DD'),
                },
                this_year: {
                    start_ts: moment().startOf('year').format('YYYY-MM-DD'),
                    end_ts: moment().format('YYYY-MM-DD'),
                },
                clear: {
                    start_ts: null,
                    end_ts: null,
                },
            },
            output: {
                start_ts: null,
                end_ts: null,
            },
            chosen_period_name: '',
        }
    },
    computed: {
        period_names() {
            const names = [
                {
                    name: this.$t('period_names.today'),
                    value: 'today',
                },
                {
                    name: this.$t('period_names.yesterday'),
                    value: 'yesterday',
                },
                {
                    name: this.$t('period_names.seven_days'),
                    value: 'seven_days',
                },
                {
                    name: this.$t('period_names.thirty_days'),
                    value: 'thirty_days',
                },
                {
                    name: this.$t('period_names.this_month'),
                    value: 'this_month',
                },
                {
                    name: this.$t('period_names.last_month'),
                    value: 'last_month',
                },
            ]
            if (this.all_filters) {
                names.push({
                    name: this.$t('period_names.three_months'),
                    value: 'three_months',
                })
                names.push({
                    name: this.$t('period_names.this_year'),
                    value: 'this_year',
                })
            }
            return names
        },
        period: {
            get: function () {
                if (
                    this.default_period.start_ts ===
                        this.periods.today.start_ts &&
                    this.default_period.end_ts === this.periods.today.end_ts
                ) {
                    return 'today'
                } else if (
                    this.default_period.start_ts ===
                        this.periods.yesterday.start_ts &&
                    this.default_period.end_ts === this.periods.yesterday.end_ts
                ) {
                    return 'yesterday'
                } else if (
                    this.default_period.start_ts ===
                        this.periods.seven_days.start_ts &&
                    this.default_period.end_ts ===
                        this.periods.seven_days.end_ts
                ) {
                    return 'seven_days'
                } else if (
                    this.default_period.start_ts ===
                        this.periods.thirty_days.start_ts &&
                    this.default_period.end_ts ===
                        this.periods.thirty_days.end_ts
                ) {
                    return 'thirty_days'
                } else if (
                    this.default_period.start_ts ===
                        this.periods.this_month.start_ts &&
                    this.default_period.end_ts ===
                        this.periods.this_month.end_ts &&
                    this.chosen_period_name === 'this_month'
                ) {
                    return 'this_month'
                } else if (
                    this.default_period.start_ts ===
                        this.periods.last_month.start_ts &&
                    this.default_period.end_ts ===
                        this.periods.last_month.end_ts
                ) {
                    return 'last_month'
                } else if (
                    this.default_period.start_ts ===
                        this.periods.three_months.start_ts &&
                    this.default_period.end_ts ===
                        this.periods.three_months.end_ts
                ) {
                    return 'three_months'
                } else if (
                    this.default_period.start_ts ===
                        this.periods.this_year.start_ts &&
                    this.default_period.end_ts === this.periods.this_year.end_ts
                ) {
                    return 'this_year'
                } else {
                    return ''
                }
            },
            set: function (newValue) {
                this.chosen_period_name = newValue
                this.output = this.periods[newValue]
            },
        },
        periodRange: {
            get: function () {
                if (
                    !this.default_period.start_ts &&
                    !this.default_period.end_ts
                ) {
                    return [null, null]
                } else {
                    return [
                        moment(
                            this.default_period.start_ts,
                            'YYYY-MM-DD',
                        ).format('X') * 1000,
                        moment(this.default_period.end_ts, 'YYYY-MM-DD').format(
                            'X',
                        ) * 1000,
                    ]
                }
            },
            set: function (newValue) {
                if (newValue[0] && newValue[1]) {
                    this.output = {
                        start_ts: moment(newValue[0])
                            .startOf('day')
                            .format('YYYY-MM-DD'),
                        end_ts: moment(newValue[1])
                            .endOf('day')
                            .format('YYYY-MM-DD'),
                    }
                } else {
                    this.output = this.periods.clear
                }
            },
        },
    },
    watch: {
        output(newValue, oldValue) {
            this.$emit('changePeriod', newValue)
        },
    },
}
</script>

<style lang="stylus">
.filters
    display flex
    align-items center
    justify-content space-between
    flex-wrap wrap
    +max-w-850()
        flex-direction column
        align-items flex-start
    &__el
        margin-right 20px
        margin-bottom 15px
        +max-w-550()
            width 100%
            margin-right 0
    &__datepicker
        width 260px

.mx
    &-datepicker-popup
        margin-top 10px
        border-radius 4px
    &-datepicker-main
        font-family 'Open Sans', sans-serif
        color $black
    &-calendar-content .cell:hover
        color $black
        background-color #fff5ce

    &-input
        height 31px
        padding-top 4px
        padding-bottom 4px
        &:hover,
        &:focus
            border-color $yellow

    &-calendar-content
        & .cell.active
            background-color $yellow
            color $black
        & .cell.in-range
            background-color #fff5ce
            color $black
    &-calendar
        border-left-color $silver

    &-table-date .today
        color $orange

    &-btn
        color $black
        &:hover
            border-color $orange
            color $orange
        &^[0]-datepicker-btn-confirm
            border-radius 4px
            display inline-block
            padding 8px 18px
            border 1px solid $yellow
            background-color $yellow
            border-bottom 3px solid $darkYellow
            fontSize(13,14)
            white-space nowrap
            color $black
            cursor pointer
            user-select none
    &-datepicker-footer
        padding 10px 15px
        border-top-color $silver
    &-calendar-header
        height 50px
        line-height 50px
        border-bottom 1px solid $silver
        margin-bottom 10px
</style>
